import React, { ChangeEventHandler, ReactNode } from 'react';
import FormsElementContainer from '../FormsElementContainer/FormsElementContainer';

// Enumerables
import { TooltipPlacement } from '../../../../atoms/Tooltip';
import { FormLabelContainerModifier, FormLabelModifier } from '../FormLabel/FormLabel';

// Components
import FormLabel from '../FormLabel/FormLabel';
import bem from '../../../../../lib/bemUtils/bem';

export enum FormCheckboxModifier {
  HEIGHT100 = 'height100',
  SWITCH = 'switch',
}

type FormCheckboxType = {
  layout?: 'switch';
  id: string;
  name: string;
  disabled?: boolean;
  labelHidden?: boolean;
  value?: boolean | string;
  labelTitle: ReactNode | string;
  labelHelpText?: string;
  tooltipPlacement?: TooltipPlacement;
  checked?: boolean;
  ariaControls?: string;
  modifier?: FormCheckboxModifier;
  modifierLabel?: FormLabelModifier;
  modifierLabelContainer?: FormLabelContainerModifier;
  required?: boolean;
  onChange?: ChangeEventHandler<HTMLInputElement>;
};

export default function FormCheckbox({
  layout,
  id,
  name,
  disabled = false,
  labelHidden = false,
  value = true,
  labelTitle,
  labelHelpText = '',
  tooltipPlacement = undefined,
  checked,
  ariaControls,
  // Modifier
  modifier,
  modifierLabel,
  modifierLabelContainer,
  // Validations
  required = false,
  // Events
  onChange,
}: FormCheckboxType) {
  const idInput = `${name}-${id}`;

  const getModifier = (): FormLabelModifier[] => {
    if (modifierLabel) {
      if (layout === 'switch') {
        return [FormLabelModifier.SWITCH].concat(modifierLabel);
      }
      return [FormLabelModifier.CHECKBOX].concat(modifierLabel);
    }
    if (layout === 'switch') {
      return [FormLabelModifier.SWITCH];
    }
    return [FormLabelModifier.CHECKBOX];
  };

  const getCheckbox = () => {
    return (
      <>
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
        <input
          id={idInput}
          className={
            layout === 'switch'
              ? bem('form-checkbox', FormCheckboxModifier.SWITCH)
              : bem('form-checkbox', modifier || null)
          }
          type="checkbox"
          name={name}
          checked={checked}
          required={required}
          disabled={disabled}
          value={typeof value === 'string' ? value : value.toString()}
          // Events
          onChange={onChange}
          aria-controls={ariaControls}
        />
        <FormLabel
          layout={layout}
          htmlFor={idInput}
          required={required}
          hidden={labelHidden}
          helpText={labelHelpText}
          tooltipPlacement={tooltipPlacement}
          modifier={getModifier()}
          containerModifier={
            modifierLabelContainer
              ? [FormLabelContainerModifier.NO_MARGIN, modifierLabelContainer]
              : FormLabelContainerModifier.NO_MARGIN
          }
        >
          {labelTitle}
        </FormLabel>
      </>
    );
  };

  const getContainerClass = () => {
    const containerClass = ['form-checkbox__container'];
    if (layout === 'switch') {
      containerClass.push('form-checkbox__container--switch');
    }
    return containerClass.join(' ');
  };

  return (
    <FormsElementContainer>
      <span className={getContainerClass()}>{getCheckbox()}</span>
    </FormsElementContainer>
  );
}
